import cn from 'classnames';
import * as styles from './Inputs.module.scss';

type InputProps = {
    name: string,
    label: string,
    disabled?: boolean,
    readonly?: boolean,
    value?: number,
    className?: string,
    maxLength?: number,
    error?: string,
    children?: React.ReactNode;
    onChange?: (value: number) => void;
    onBlur?: (value: number) => void;
};


export const InputNumber = ({
    name, 
    label, 
    disabled=false, 
    readonly=false,
    value,
    className,
    maxLength,
    error,
    children,
    onChange,
    onBlur
}: InputProps) => {
    return (<div className="form-text">
    <input
        type="number"
        name={name}
        placeholder={label}
        disabled={disabled}
        readOnly={readonly ? readonly : false}
        value={value}
        className={cn(className, styles.numberInput)}
        maxLength={maxLength}
        onChange={ev => onChange?.(ev.target.valueAsNumber)}
        onBlur={ev => onBlur?.(ev.target.valueAsNumber)}
    />
    <label htmlFor={name}>
        <span>{label}</span>
        {
            maxLength && <span>{length}/{maxLength}</span>
        }
    </label>
    {children && <div className={styles.suffix}>{children}</div>}
    {error && <span className="form-error">{error}</span>}
</div>)
}